import { useState } from "react";
import "./CtaFinal.css";
import PetAnimations from "../PetAnimations";
import { emailApi } from "../../config/emailSenderApi";

function validate(form) {
  const errors = {};
  if (!form.nome.trim()) errors.nome = "Informe seu nome";
  if (!form.email.trim() || !/\S+@\S+\.\S+/.test(form.email))
    errors.email = "E-mail inválido";
  if (!form.telefone.trim() || form.telefone.replace(/\D/g, "").length < 10)
    errors.telefone = "Telefone inválido (mínimo 10 dígitos)";
  return errors;
}

export default function CtaFinal() {
  const [form, setForm] = useState({ nome: "", email: "", telefone: "" });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const handleChange = (field) => (e) => {
    setForm((f) => ({ ...f, [field]: e.target.value }));
    setErrors((err) => ({ ...err, [field]: undefined }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate(form);
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }

    setStatus("sending");
    try {
      await emailApi.post("sendUniversalLPEmail", {
        recipientEmail: "contato@amanimalshop.com.br",
        subject: `Amanimal Shop — Contato: ${form.nome}`,
        lpName: "Amanimal Shop",
        colors: {
          primaryColor: "#5B3B8C",
          secondaryColor: "#F4F0FB",
          accentColor: "#2D1B69",
          backgroundColor: "#FFFFFF",
          textColor: "#111827",
        },
        name: form.nome,
        phone: form.telefone,
        email: form.email,
        message: "Novo cadastro recebido pelo formulário do site Amanimal Shop.",
      });
      setStatus("success");
      setSubmitted(true);
    } catch {
      setStatus("error");
    }
  };

  return (
    <section id="contato" className="cta">
      <PetAnimations />
      <span className="section-tag cta__tag">Faça parte</span>
      <h2 className="section-title cta__title">
        Receba novidades
        <br />e apoie a causa
      </h2>
      <p className="cta__sub">
        Preencha o formulário e fique por dentro de novos lançamentos, histórias
        de adoção e como sua compra está transformando vidas.
      </p>

      {submitted ? (
        <div className="cta__success">
          <div className="cta__success-icon">🐾</div>
          <h3>Obrigado, {form.nome.split(" ")[0]}!</h3>
          <p>
            Você agora faz parte da família Amanimal. Em breve entraremos em
            contato.
          </p>
        </div>
      ) : (
        <form className="cta__form" onSubmit={handleSubmit} noValidate>
          <div className="cta__field">
            <input
              className={`cta__input${errors.nome ? " cta__input--error" : ""}`}
              type="text"
              placeholder="Seu nome completo"
              value={form.nome}
              onChange={handleChange("nome")}
            />
            {errors.nome && <span className="cta__error">{errors.nome}</span>}
          </div>

          <div className="cta__field">
            <input
              className={`cta__input${errors.email ? " cta__input--error" : ""}`}
              type="email"
              placeholder="Seu melhor e-mail"
              value={form.email}
              onChange={handleChange("email")}
            />
            {errors.email && <span className="cta__error">{errors.email}</span>}
          </div>

          <div className="cta__field">
            <input
              className={`cta__input${errors.telefone ? " cta__input--error" : ""}`}
              type="tel"
              placeholder="Telefone / WhatsApp (ex: 11 91234-5678)"
              value={form.telefone}
              onChange={handleChange("telefone")}
            />
            {errors.telefone && (
              <span className="cta__error">{errors.telefone}</span>
            )}
          </div>

          <button
            className="cta__submit"
            type="submit"
            disabled={status === "sending"}
          >
            {status === "sending" ? "Enviando..." : "Quero apoiar a causa 🐾"}
          </button>

          {status === "error" && (
            <span className="cta__error cta__error--submit">
              Não foi possível enviar agora. Tente novamente em instantes.
            </span>
          )}
        </form>
      )}
    </section>
  );
}
